import { faUser } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { snakeToTitleCase } from '@domain-group/javascript-utils'

import { DashboardModuleListItem, ListItem, UserProfileImage } from '@domain-group/suit-theme'

import { AgentsAndMembers } from '@functions/campaign'

import useTeamMember from '@hooks/useTeamMember'

interface TeamMemberItem {
  member: AgentsAndMembers,
}

const TeamMember = (props: TeamMemberItem) => {
  const { member } = props

  const { member_role } = member || {}

  const { image, user } = useTeamMember(member)

  return (
    <ListItem boxProps={{ alignItems: 'center', borderBottom: '1px dashed' }} disableHover>
      {/*
       // @ts-expect-error TS2339 */}
      <UserProfileImage imageUrl={image?.thumb_url}>
        <FontAwesomeIcon icon={faUser} />
      </UserProfileImage>

      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem secondaryText={snakeToTitleCase(member_role)} title={user.full_name} />
    </ListItem>
  )
}

export default TeamMember
